import { Form, useFormikContext } from "formik";
import { Col, Row } from "react-bootstrap";
import Section from "../../components/section/Section";
import React from "react";
import { useOutletContext } from "react-router-dom";
import { IMainProgramConfigBuilder } from "../../models/config";
import Switch from "../../components/switch/Switch";

export const CustomHtmlSection = () => {
  const { editor } = useOutletContext<any>();
  const { values } = useFormikContext<IMainProgramConfigBuilder>();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const body: Partial<IMainProgramConfigBuilder> = {
      custom_header_enabled: values.custom_header_enabled ? 1 : 0,
      custom_header_html: values.custom_header_html ?? null,
      custom_footer_enabled: values.custom_footer_enabled ? 1 : 0,
      custom_footer_html: values.custom_footer_html ?? null,
    };
    await editor?.onSubmit?.(body);
  };

  return (
    <Form id="config-form-submit" onSubmit={onSubmit}>

      <Section sectionId="custom-header-section" title="Custom Site Header">
        <Row className="mb-3">
          <Col md={4}>
            <div className="admin-editor-toggle">
              <p>Enable custom site header</p>
              <Switch
                checked={!!values.custom_header_enabled}
                onChange={() => {
                  editor.onChange("custom_header_enabled")(!values.custom_header_enabled);
                }}
                switchId="custom-header-enabled-toggle"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="input-container secondary">
              <div className="input-label-row">Custom Header HTML</div>
              <textarea
                className="form-control"
                rows={10}
                placeholder="Paste your custom header HTML here..."
                value={values.custom_header_html ?? ""}
                onChange={(e) => editor.onChange("custom_header_html")(e.target.value)}
                style={{ fontFamily: "monospace", fontSize: "13px" }}
              />
              <small className="text-muted">
                HTML is saved and rendered as-is on the client site when the toggle above is enabled.
                The existing site header will be hidden.
              </small>
            </div>
          </Col>
        </Row>
      </Section>

      <Section sectionId="custom-footer-section" title="Custom Site Footer" className="mt-4">
        <Row className="mb-3">
          <Col md={4}>
            <div className="admin-editor-toggle">
              <p>Enable custom site footer</p>
              <Switch
                checked={!!values.custom_footer_enabled}
                onChange={() => {
                  editor.onChange("custom_footer_enabled")(!values.custom_footer_enabled);
                }}
                switchId="custom-footer-enabled-toggle"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="input-container secondary">
              <div className="input-label-row">Custom Footer HTML</div>
              <textarea
                className="form-control"
                rows={10}
                placeholder="Paste your custom footer HTML here..."
                value={values.custom_footer_html ?? ""}
                onChange={(e) => editor.onChange("custom_footer_html")(e.target.value)}
                style={{ fontFamily: "monospace", fontSize: "13px" }}
              />
              <small className="text-muted">
                HTML is saved and rendered as-is on the client site when the toggle above is enabled.
                The existing site footer will be hidden.
              </small>
            </div>
          </Col>
        </Row>
      </Section>

    </Form>
  );
};
